















import { TranslateResult } from "vue-i18n";
import { Component, Inject, Vue } from "vue-property-decorator";
import { PORTAL_TARGET } from "..";

@Component
export default class E404 extends Vue {
    @Inject() i18n!: (key: string, values?: unknown) => TranslateResult;

    goBack(): void {
        this.$router.back();
    }

    get portalTarget(): string {
        return PORTAL_TARGET;
    }
}
